document.addEventListener('DOMContentLoaded', function () {
  let cart = 0;
  window.bumpCart = function () {
    cart++;
    var el = document.getElementById('cartCount');
    if (el) el.textContent = cart;
  };

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.fade-in').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fade-in').forEach(function (el) { el.classList.add('visible'); });
  }

  var newsForm = document.querySelector('.news-form');
  if (newsForm) {
    newsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var btn = newsForm.querySelector('button');
      if (btn) btn.textContent = 'Thank you ✓';
    });
  }
});
